var map = {
	"./ad.svg": 2105,
	"./ae.svg": 9055,
	"./af.svg": 9379,
	"./ag.svg": 9202,
	"./ai.svg": 419,
	"./al.svg": 3869,
	"./am.svg": 3621,
	"./ao.svg": 4083,
	"./aq.svg": 329,
	"./ar.svg": 1000,
	"./as.svg": 2383,
	"./at.svg": 3010,
	"./au.svg": 9808,
	"./aw.svg": 9088,
	"./ax.svg": 870,
	"./az.svg": 8627,
	"./ba.svg": 2189,
	"./bb.svg": 7779,
	"./bd.svg": 62,
	"./be.svg": 8195,
	"./bf.svg": 7233,
	"./bg.svg": 9483,
	"./bh.svg": 3947,
	"./bi.svg": 4302,
	"./bj.svg": 330,
	"./bl.svg": 2334,
	"./bm.svg": 194,
	"./bn.svg": 7395,
	"./bo.svg": 3222,
	"./bq.svg": 9802,
	"./br.svg": 8209,
	"./bs.svg": 415,
	"./bt.svg": 4424,
	"./bv.svg": 9542,
	"./bw.svg": 6339,
	"./by.svg": 9445,
	"./bz.svg": 9187,
	"./ca.svg": 3296,
	"./cc.svg": 5100,
	"./cd.svg": 2234,
	"./cf.svg": 883,
	"./cg.svg": 8482,
	"./ch.svg": 4834,
	"./ci.svg": 3272,
	"./ck.svg": 7856,
	"./cl.svg": 716,
	"./cm.svg": 8507,
	"./cn.svg": 5145,
	"./co.svg": 987,
	"./cr.svg": 9026,
	"./cu.svg": 5741,
	"./cv.svg": 8262,
	"./cw.svg": 7865,
	"./cx.svg": 467,
	"./cy.svg": 8438,
	"./cz.svg": 6048,
	"./de.svg": 1827,
	"./dj.svg": 5402,
	"./dk.svg": 4533,
	"./dm.svg": 9733,
	"./do.svg": 6340,
	"./dz.svg": 4494,
	"./ec.svg": 3256,
	"./ee.svg": 8997,
	"./eg.svg": 5398,
	"./eh.svg": 9754,
	"./er.svg": 2810,
	"./es-ca.svg": 7697,
	"./es.svg": 8472,
	"./et.svg": 8601,
	"./eu.svg": 2098,
	"./fi.svg": 7923,
	"./fj.svg": 18,
	"./fk.svg": 274,
	"./fm.svg": 6394,
	"./fo.svg": 3942,
	"./fr.svg": 758,
	"./ga.svg": 210,
	"./gb-eng.svg": 7354,
	"./gb-nir.svg": 7722,
	"./gb-sct.svg": 1554,
	"./gb-wls.svg": 5273,
	"./gb.svg": 6522,
	"./gd.svg": 3957,
	"./ge.svg": 4962,
	"./gf.svg": 8093,
	"./gg.svg": 7038,
	"./gh.svg": 7099,
	"./gi.svg": 5793,
	"./gl.svg": 6962,
	"./gm.svg": 7925,
	"./gn.svg": 1857,
	"./gp.svg": 5826,
	"./gq.svg": 7415,
	"./gr.svg": 5874,
	"./gs.svg": 3043,
	"./gt.svg": 3739,
	"./gu.svg": 607,
	"./gw.svg": 6656,
	"./gy.svg": 7318,
	"./hk.svg": 9821,
	"./hm.svg": 513,
	"./hn.svg": 7615,
	"./hr.svg": 3578,
	"./ht.svg": 7566,
	"./hu.svg": 6650,
	"./id.svg": 8117,
	"./ie.svg": 6405,
	"./il.svg": 7680,
	"./im.svg": 565,
	"./in.svg": 6217,
	"./io.svg": 3973,
	"./iq.svg": 2750,
	"./ir.svg": 1782,
	"./is.svg": 8577,
	"./it.svg": 5480,
	"./je.svg": 6768,
	"./jm.svg": 8780,
	"./jo.svg": 9433,
	"./jp.svg": 9099,
	"./ke.svg": 821,
	"./kg.svg": 1733,
	"./kh.svg": 8859,
	"./ki.svg": 8968,
	"./km.svg": 7102,
	"./kn.svg": 8264,
	"./kp.svg": 9280,
	"./kr.svg": 4253,
	"./kw.svg": 261,
	"./ky.svg": 5590,
	"./kz.svg": 8820,
	"./la.svg": 1029,
	"./lb.svg": 9285,
	"./lc.svg": 1233,
	"./li.svg": 9982,
	"./lk.svg": 2138,
	"./lr.svg": 7221,
	"./ls.svg": 1385,
	"./lt.svg": 9025,
	"./lu.svg": 1191,
	"./lv.svg": 9660,
	"./ly.svg": 3284,
	"./ma.svg": 1442,
	"./mc.svg": 6801,
	"./md.svg": 2920,
	"./me.svg": 707,
	"./mf.svg": 9034,
	"./mg.svg": 5197,
	"./mh.svg": 8130,
	"./mk.svg": 341,
	"./ml.svg": 5791,
	"./mm.svg": 9566,
	"./mn.svg": 6804,
	"./mo.svg": 3936,
	"./mp.svg": 856,
	"./mq.svg": 2719,
	"./mr.svg": 9813,
	"./ms.svg": 3697,
	"./mt.svg": 4288,
	"./mu.svg": 8976,
	"./mv.svg": 2440,
	"./mw.svg": 6576,
	"./mx.svg": 7765,
	"./my.svg": 7201,
	"./mz.svg": 8081,
	"./na.svg": 7051,
	"./nc.svg": 7383,
	"./ne.svg": 1864,
	"./nf.svg": 7908,
	"./ng.svg": 5942,
	"./ni.svg": 5504,
	"./nl.svg": 7707,
	"./no.svg": 6205,
	"./np.svg": 9499,
	"./nr.svg": 2031,
	"./nu.svg": 2738,
	"./nz.svg": 9487,
	"./om.svg": 5828,
	"./pa.svg": 9306,
	"./pe.svg": 9184,
	"./pf.svg": 295,
	"./pg.svg": 4637,
	"./ph.svg": 9671,
	"./pk.svg": 8514,
	"./pl.svg": 7589,
	"./pm.svg": 9357,
	"./pn.svg": 8071,
	"./pr.svg": 2485,
	"./ps.svg": 8297,
	"./pt.svg": 7344,
	"./pw.svg": 838,
	"./py.svg": 235,
	"./qa.svg": 5247,
	"./race-flag.svg": 845,
	"./re.svg": 540,
	"./ro.svg": 2133,
	"./rs.svg": 7372,
	"./ru.svg": 3005,
	"./rw.svg": 1655,
	"./sa.svg": 1935,
	"./sb.svg": 7624,
	"./sc.svg": 6094,
	"./sd.svg": 1235,
	"./se.svg": 2594,
	"./sg.svg": 1690,
	"./sh.svg": 7136,
	"./si.svg": 9615,
	"./sj.svg": 7020,
	"./sk.svg": 6626,
	"./sl.svg": 4723,
	"./sm.svg": 7376,
	"./sn.svg": 7118,
	"./so.svg": 9528,
	"./sr.svg": 3335,
	"./ss.svg": 753,
	"./st.svg": 5275,
	"./sv.svg": 8770,
	"./sx.svg": 6890,
	"./sy.svg": 4700,
	"./sz.svg": 671,
	"./tc.svg": 2153,
	"./td.svg": 5506,
	"./tf.svg": 5164,
	"./tg.svg": 5189,
	"./th.svg": 8932,
	"./tj.svg": 3648,
	"./tk.svg": 4438,
	"./tl.svg": 8897,
	"./tm.svg": 5675,
	"./tn.svg": 7693,
	"./to.svg": 2833,
	"./tr.svg": 3088,
	"./tt.svg": 3690,
	"./tv.svg": 4137,
	"./tw.svg": 3170,
	"./tz.svg": 6936,
	"./ua.svg": 8800,
	"./ug.svg": 9840,
	"./um.svg": 9529,
	"./un.svg": 4115,
	"./us.svg": 2030,
	"./uy.svg": 9084,
	"./uz.svg": 3169,
	"./va.svg": 2922,
	"./vc.svg": 1112,
	"./ve.svg": 8664,
	"./vg.svg": 4726,
	"./vi.svg": 2404,
	"./vn.svg": 9405,
	"./vu.svg": 4277,
	"./wf.svg": 5458,
	"./ws.svg": 7,
	"./xk.svg": 9889,
	"./ye.svg": 4659,
	"./yt.svg": 4414,
	"./za.svg": 2102,
	"./zm.svg": 452,
	"./zw.svg": 7226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1228;